import { Link } from '@beef/ui-kit';
import React, { useEffect } from 'react';
import { shallowEqual, useDispatch, useSelector } from 'react-redux';
import classNames from 'classnames/bind';

import { getTradeInEstimate, isTradeInActive } from 'store/widgets/TradeInCalculator/selectors';
import commonStyles from 'styles/common.pcss';
import { ContentLiner } from 'bricks';
import { isScreenBelow640 } from 'store/common/settings/breakpoint/selectors';
import { fetchTradeInTextsThunk } from 'store/common/tradeIn/actions';

import { BannerText } from './components/BannerText';
import styles from './styles.pcss';

const cx = classNames.bind({ ...commonStyles, ...styles });

export const TradeInBanner = () => {
  const { isMobile, estimate, isActive } = useSelector(
    (state) => ({
      isMobile: isScreenBelow640(state),
      estimate: getTradeInEstimate(state),
      isActive: isTradeInActive(state),
    }),
    shallowEqual,
  );
  const dispatch = useDispatch();

  useEffect(() => {
    dispatch(fetchTradeInTextsThunk());
  }, [dispatch]);

  if (!isActive) {
    return null;
  }

  return (
    <div className={cx('banner', isMobile && 'mobile')}>
      <ContentLiner isUnderlay size={['xl']} className={cx('padh-s')}>
        <div className={cx('wrapper', isMobile && 'mobile')}>
          <div className={cx('text-wrapper')}>
            <BannerText
              maxPrice={estimate.maxPrice}
              deviceType={estimate.deviceType}
              deviceBrand={estimate.deviceBrand}
              deviceModel={estimate.deviceModel}
            />
          </div>
          <span className={cx('separator')} />
          <div className={cx('link-wrapper')}>
            <Link variant="light" href="/shop/trade-in" size="size5-m" color="white" isNoUnderline>
              Другое устройство
            </Link>
          </div>
        </div>
      </ContentLiner>
    </div>
  );
};
